export function sync<T, E = Error>(fn: () => T): [E, undefined] | [undefined, T] {
  try {
    return [undefined, fn()]
  } catch (err) {
    return [err as E, undefined]
  }
}

export async function async<T, E = Error>(
  fn: () => Promise<T>,
): Promise<[E, undefined] | [undefined, T]> {
  try {
    const data = await fn()
    return [undefined, data]
  } catch (err) {
    return [err as E, undefined]
  }
}
